<div class="modal-header">
    <h4 class="modal-title fw-bold">{{title | translate}}</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="closeModal()">
    </button>
</div>
<div class="modal-body">
    <div *ngIf="!this.isReadOnly" class="row mb-3 modal-popover ">
        <div class="col-md-7 d-flex align-items-center">
            <label class="fw-bold" for="studyType">{{ 'common.study.type' | translate}}:</label>
            <div class="ms-2 w-40">
                <ng-select name="studyType" id="studyType" [(ngModel)]="filterStudyType" [clearable]="false" (ngModelChange)="onStudyTypeChange()"
                           placeholder="{{ 'common.select.study.type' | translate}}">
                    <ng-option value="">{{ 'show-all' | translate }}</ng-option>
                    <ng-option value="T">{{ 'common.trial' | translate }}</ng-option>
                    <ng-option value="N">{{ 'common.nursery' | translate }}</ng-option>
                </ng-select>
            </div>
        </div>
        <div class="col-md-5">
            <div class="float-end">
                <img *jhiHasAnyAuthority="STUDY_FOLDER_ACTIONS_ADD_PERMISSION" (click)="setMode(Modes.Add, $event)" src="content/images/add2.png" class=""
                     [ngClass]="{ 'disable-image': this.isAddActionDisabled() }" [attr.title]="this.isAddActionDisabled() ? this.disabledAddActionMessage : ''"/>
                <img *jhiHasAnyAuthority="STUDY_FOLDER_ACTIONS_RENAME_PERMISSION" (click)="setMode(Modes.Rename, $event)" src="content/images/edit.png" class="ps-1"
                     [ngClass]="{ 'disable-image': this.isRenameActionDisabled() }" [attr.title]="this.isRenameActionDisabled() ? this.disabledRenameActionMessage : ''"/>
                <img *jhiHasAnyAuthority="STUDY_FOLDER_ACTIONS_DELETE_PERMISSION" (click)="setMode(Modes.Delete, $event)" src="content/images/delete.png" class="ps-1"
                     [ngClass]="{ 'disable-image': this.isDeleteActionDisabled() }" [attr.title]="this.isDeleteActionDisabled() ? this.disabledDeleteActionMessage : ''"/>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-xs-12 col-md-12">
            <div *ngIf="!this.isReadOnly" class="form-horizontal mb-3">
                <div id="addFolderDiv" *ngIf="mode == Modes.Add || mode == Modes.Rename">
                    <div class="mb-3 row">
                        <div class="col-3">
                            <label class="fw-bold" for="renameFolder">{{ 'common.folder.action.' + Modes[mode].toString().toLowerCase() | translate }}</label>
                        </div>
                        <div class="col-9">
                            <div class="input-group">
                                <input id="renameFolder" type="text" class="form-control" placeholder="{{'common.folder.name' | translate}}" [(ngModel)]="this.name" jhi-forbiddenCharactersValidator [required]="true"  maxlength="{{ NAME_MAX_LENGTH }}"/>
                                <button class="btn btn-success" [title]="'common.folder.title.' + Modes[mode].toString().toLowerCase() | translate " [disabled]="containsForbiddenCharacters(name)" (click)="submitAddOrRenameFolder()">
                                    <span class="fa fa-check"></span>
                                </button>
                                <button class="btn btn-danger" title="{{ 'common.form.cancel.text' | translate }}" (click)="mode = Modes.None">
                                    <span class="fa fa-times"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="table-responsive custom-scroll-style" style="max-height: 800px; overflow-y: auto;">
                <p-tree [value]="nodes"
                        [(selection)]="_selectedNodes"
                        [draggableNodes]="true"
                        [droppableNodes]="true"
                        [validateDrop]="true"
                        (onNodeSelect)="onNodeSelect($event)"
                        (onNodeDrop)="onNodeDrop($event, $event.dragNode, $event.dropNode)"
                        (onNodeExpand)="onNodeExpand($event)"
                        autoLayout="true"
                        [selectionMode]="selectionMode"
                        draggableScope="self"
                        droppableScope="self"
                        styleClass="tree-table">
                    <ng-template pTemplate="default" let-node>
                        <span [ngClass]="{ 'folder': !node.leaf, 'file': node.leaf }"></span>
                        {{translateName(node.data)}}
                    </ng-template>
                </p-tree>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">{{ 'cancel' | translate}}</button>
    <button *ngIf="!hideViewSummaryButton" type="button" class="btn btn-primary" aria-hidden="true" (click)="viewSummary({ showSummary: true })">{{ 'entity.action.view.summary' | translate}}</button>
    <ng-container *ngIf="!showOpenFolderButton" >
        <button type="button" class="btn btn-primary" aria-hidden="true" *jhiHasAnyAuthority="STUDIES_EDITION_PERMISSIONS" (click)="open()">{{ 'entity.action.open' | translate}}</button>
    </ng-container>
    <ng-container *ngIf="showOpenFolderButton">
        <button type="button" class="btn btn-primary" aria-hidden="true" *jhiHasAnyAuthority="STUDIES_EDITION_PERMISSIONS" (click)="openFolder()">{{ (openFolderButtonKey || 'entity.action.open') | translate }}</button>
    </ng-container>

</div>
